module.exports = __webpack_public_path__ + "static/media/logo-precidia-rentals-green.08d4ff1a.svg";